import React from "react";
import FHAFamily from "../../PicesForPages/FHA_family2.png";
import FreeConsultation from "../Form/FreeConsultation";

function FHA() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent FHALoansTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={FHAFamily}
          alt="FHAFamilyImage"
          className="background-video FHA_FamilyImage"
        />
        <div className="purchasetopBox FHALoansTopBox">
          {/* The existing Purchase span */}
          <span>FHA Loans</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              FHA loans have been empowering individuals to achieve
              homeownership since 1934.
            </span>
            <span className="purchaseBottomLeftHeader">
              Key benefits of FHA loans include:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Low down payment requirements</li>
              <li>Cost-effective closing expenses</li>
              <li>Flexible credit qualification criteria</li>
            </ul>
            <span className="purchaseBottomLeftHeader">
              What opportunities can FHA provide for you?
            </span>
            <span className="purchaseBottomLeftSubHeader">
              Are you a first-time homebuyer?
            </span>
            <span className="purchaseBottomLeftContent">
              FHA may be the perfect solution you’ve been searching for. With a
              down payment starting at just 3.5% of the purchase price, you may
              also be able to finance many of your closing costs and fees into
              the loan. FHA loans are available for properties with 1–4 units.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Thinking about buying a fixer-upper?
            </span>
            <span className="purchaseBottomLeftContent">
              FHA offers financing options that let you purchase, renovate, and
              combine all costs into one convenient loan. If you already own a
              home and want to upgrade or repair it, you can refinance your
              current mortgage and include renovation expenses.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Financial support for seniors
            </span>
            <span className="purchaseBottomLeftContent">
              Are you 62 years of age or older? Do you fully own your home or
              have a low remaining balance? If so, an FHA Reverse Mortgage could
              be an excellent choice. This program enables you to convert a
              portion of your home equity into cash.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Looking to improve your home’s energy efficiency?
            </span>
            <span className="purchaseBottomLeftContent">
              You can roll the cost of energy-efficient upgrades into an FHA
              Energy-Efficient Mortgage.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Considering manufactured or mobile homes?
            </span>
            <span className="purchaseBottomLeftContent">
              Absolutely—FHA provides financing for mobile and factory-built
              homes. Two options are available: one for homes on owned land and
              another for homes in mobile home communities or planned
              placements.
            </span>

            <span className="purchaseBottomLeftHeader">
              FHA loans have supported homeownership since 1934—but how does it
              work?
            </span>
            <span className="purchaseBottomLeftContent">
              The Federal Housing Administration (FHA), part of HUD, insures the
              loan, enabling lenders to offer more favorable terms.
            </span>
            <span className="purchaseBottomLeftContent">
              FHA allows buyers to secure a home with as little as 3.5% down.
              The program is typically more flexible regarding credit, closing
              funds, and co-borrower eligibility.
            </span>
            <span className="purchaseBottomLeftContent">
              Unlike many loan programs that rely heavily on credit scores, FHA
              does not enforce a strict minimum score requirement. Even
              borrowers with lower scores may qualify if they can demonstrate a
              strong ability to repay. FHA evaluates recent credit behavior,
              particularly over the past 12 to 24 months. A solid payment
              history during this time can lead to approval—even when
              conventional financing isn’t an option.
            </span>
            <span className="purchaseBottomLeftContent">
              FHA’s flexible approach is especially beneficial for borrowers
              with previous credit challenges. In some cases, even with a larger
              down payment, FHA may offer more attractive terms than
              conventional loans.
            </span>
            <span className="purchaseBottomLeftContent">
              For FHA financing, borrowers are required to contribute at least
              3.5% of the purchase price. This amount may cover the down payment
              and part of the closing costs, although total closing expenses can
              exceed 3.5%. When factoring in taxes, insurance, and interest,
              overall closing costs may range between 6–8% of the home’s price.
            </span>
            <span className="purchaseBottomLeftContent">
              The interest rate you select will also impact your total closing
              costs. Choosing a lower rate can reduce monthly payments but may
              involve higher upfront costs, such as discount points. On the
              other hand, selecting a slightly higher rate may help lower your
              initial closing expenses.
            </span>
            <span className="purchaseBottomLeftContent">
              FHA permits multiple funding sources for closing costs, including
              personal savings, gift funds, grants, retirement account loans,
              and seller contributions.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default FHA;
